module.exports = __webpack_public_path__ + "img/3-black.fb254006.png";